











































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import SkriningPaliatifDewasaService from "@/services/SkriningPaliatifDewasa";
import TimeStamp from "@/components/pemeriksaan/assesmen/TimeStamp.vue";
import moment from "moment";

/**
 * Form input Skrining Paliatif Dewasa (RM.RJ.PAP.SPD.01).
 *
 * Katalog kriteria + bobot diambil dari endpoint `masters` (sumber tunggal =
 * App\Support\SkriningPaliatifDewasaCalculator) agar label/bobot tidak
 * terduplikasi di TS. Total skor di sini hanya PRATINJAU — server selalu
 * menghitung ulang dan menjadi sumber kebenaran.
 */
@Component({
  components: { TimeStamp },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardSkriningPaliatifDewasa extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() value!: any; // v-model edit item
  /**
   * Setting encounter tempat form dipasang. Menentukan basis "keluar" untuk
   * edit-window di server (ralan = ResumeRalan.created_at; ranap/igd =
   * cm_reg__.dout), jadi harus mencerminkan halaman induknya.
   */
  @Prop({ default: "ralan" }) encounterType!: string;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  valid = true;
  saving = false;
  menuUlang = false;

  id: number = null;
  kriteria: any[] = [];
  usiaMinDewasa = 18;
  catatanVerifikasi = "";

  checked: { [k: string]: boolean } = {};
  ecogKategori: string = null;
  umurTahun: number = null;
  rujukPaliatif = false;
  tanggalSkriningUlang: string = null;
  catatanTindakLanjut = "";
  examinedAt = moment().format("YYYY-MM-DD HH:mm:ss");

  mounted() {
    this.loadMasters();
  }

  loadMasters() {
    SkriningPaliatifDewasaService.masters().then(resp => {
      if (!resp || !resp.data) return;
      this.kriteria = resp.data.kriteria || [];
      this.usiaMinDewasa = resp.data.usia_min_dewasa || 18;
      this.catatanVerifikasi = resp.data.catatan_verifikasi || "";
      // Inisialisasi SEMUA kunci agar reaktif di Vue 2.
      const map: { [k: string]: boolean } = {};
      this.allCodes.forEach(c => (map[c] = false));
      // Pertahankan centang yang sudah ada (mis. saat edit dimuat lebih dulu).
      Object.keys(this.checked).forEach(c => {
        if (this.checked[c]) map[c] = true;
      });
      this.checked = map;
    });
  }

  get allCodes(): string[] {
    const out: string[] = [];
    this.kriteria.forEach(g => {
      if (g.tipe === "checkbox") {
        (g.items || []).forEach(i => out.push(i.code));
      }
    });
    return out;
  }

  get maxDate() {
    return moment().format("YYYY-MM-DD");
  }

  get minTanggalUlang() {
    return moment(this.examinedAt).format("YYYY-MM-DD");
  }

  get ecogSkor(): number {
    for (const g of this.kriteria) {
      if (g.tipe !== "radio") continue;
      const found = (g.items || []).find(i => i.value === this.ecogKategori);
      if (found) return found.skor;
    }
    return 0;
  }

  /** Mirror App\Support\SkriningPaliatifDewasaCalculator::hitungTotal (pratinjau). */
  get totalSkor(): number {
    let total = 0;
    this.kriteria.forEach(g => {
      if (g.tipe !== "checkbox") return;
      (g.items || []).forEach(i => {
        if (this.checked[i.code]) total += i.skor;
      });
    });
    return total + this.ecogSkor;
  }

  get kategori(): string {
    if (this.totalSkor >= 4) return "perlu_intervensi";
    if (this.totalSkor === 3) return "observasi";
    return "tidak_perlu";
  }

  get kategoriLabel(): string {
    const map = {
      tidak_perlu: "Tidak perlu intervensi paliatif",
      observasi: "Observasi",
      perlu_intervensi: "Perlu intervensi paliatif"
    };
    return map[this.kategori] || "-";
  }

  get kategoriColor(): string {
    const map = {
      tidak_perlu: "green",
      observasi: "amber darken-2",
      perlu_intervensi: "red"
    };
    return map[this.kategori] || "grey";
  }

  get kategoriHint(): string {
    const map = {
      tidak_perlu:
        "Lanjutkan tata laksana rutin; skrining ulang bila kondisi berubah.",
      observasi:
        "Pantau berkala; pertimbangkan skrining ulang dan diskusi tim.",
      perlu_intervensi:
        "Rujuk / aktifkan layanan paliatif; susun rencana asuhan paliatif."
    };
    return map[this.kategori] || "";
  }

  get usiaSesuai(): boolean {
    if (this.umurTahun === null || (this.umurTahun as any) === "") return true;
    return this.umurTahun >= this.usiaMinDewasa;
  }

  subtotal(grup): number {
    if (grup.tipe === "radio") return this.ecogSkor;
    let t = 0;
    (grup.items || []).forEach(i => {
      if (this.checked[i.code]) t += i.skor;
    });
    return t;
  }

  @Watch("value")
  onValueChange(val) {
    if (val) this.populateForm(val);
  }

  /**
   * Rujukan paliatif hanya di-DEFAULT-kan menyala saat kategori naik ke "perlu
   * intervensi" — keputusan akhir tetap milik klinisi (server tidak memaksa,
   * lihat SkriningPaliatifDewasaSession::recalculate).
   */
  @Watch("kategori")
  onKategoriChange(val: string) {
    if (val === "perlu_intervensi") this.rujukPaliatif = true;
  }

  populateForm(item) {
    this.id = item.id;
    const map: { [k: string]: boolean } = {};
    this.allCodes.forEach(c => (map[c] = false));
    (item.items || []).forEach(it => {
      if (it.dicentang) map[it.item_code] = true;
    });
    this.checked = map;
    this.ecogKategori = item.ecog_kategori;
    this.umurTahun = item.umur_tahun;
    this.rujukPaliatif = !!item.rujuk_paliatif;
    this.tanggalSkriningUlang = item.tanggal_skrining_ulang;
    this.catatanTindakLanjut = item.catatan_tindak_lanjut || "";
    this.examinedAt = item.tanggal_skrining
      ? `${item.tanggal_skrining} ${item.jam_skrining || "00:00"}:00`
      : moment().format("YYYY-MM-DD HH:mm:ss");
  }

  setTime(val) {
    this.examinedAt = val;
  }

  get sendData() {
    const items = this.allCodes
      .filter(c => this.checked[c])
      .map(c => ({ item_code: c, dicentang: true }));

    return {
      register_id: this.register,
      pasien_rm: this.rm,
      encounter_type: this.encounterType,
      tanggal_skrining: moment(this.examinedAt).format("YYYY-MM-DD"),
      jam_skrining: moment(this.examinedAt).format("HH:mm:ss"),
      umur_tahun: this.umurTahun,
      ecog_kategori: this.ecogKategori,
      rujuk_paliatif:
        this.kategori === "perlu_intervensi" ? this.rujukPaliatif : false,
      tanggal_skrining_ulang:
        this.kategori === "observasi" ? this.tanggalSkriningUlang : null,
      catatan_tindak_lanjut: this.catatanTindakLanjut || null,
      items: items
    };
  }

  save() {
    if (this.readOnly) return;
    if (!(this.$refs.form as any).validate()) return;

    if (!this.ecogKategori) {
      appModule.NoticeDelay(
        "Status Fungsional (ECOG) wajib dipilih tepat satu kategori."
      );
      return;
    }

    this.saving = true;
    const action = this.id
      ? SkriningPaliatifDewasaService.update(this.id, this.sendData)
      : SkriningPaliatifDewasaService.create(this.sendData);

    action
      .then(resp => {
        if (resp && resp.data) {
          appModule.NoticeDelay(
            this.id ? "Skrining berhasil diubah" : "Skrining berhasil disimpan"
          );
          this.resetForm();
          this.$emit("saved", resp.data);
        }
      })
      .finally(() => {
        this.saving = false;
      });
  }

  resetForm() {
    this.id = null;
    const map: { [k: string]: boolean } = {};
    this.allCodes.forEach(c => (map[c] = false));
    this.checked = map;
    this.ecogKategori = null;
    this.umurTahun = null;
    this.rujukPaliatif = false;
    this.tanggalSkriningUlang = null;
    this.catatanTindakLanjut = "";
    this.examinedAt = moment().format("YYYY-MM-DD HH:mm:ss");
    this.$emit("input", null);
    if (this.$refs.form) (this.$refs.form as any).resetValidation();
  }
}
